import json from "../json/forecastDebtPredictions.json";

export default async () => JSON.parse(JSON.stringify(await json));
